export const CONTRACT_API = `contracts`
export const COMMISSION_API = `commissions`
export const CONSULTATION_API = `consultations`
